import React from "react";
import img1 from "../assets/images/img1.png";
import img2 from "../assets/images/img2.png";
import img3 from "../assets/images/img3.png";
import img4 from "../assets/images/img4.png";
import img5 from "../assets/images/img5.png";
import img6 from "../assets/images/img6.png";
import img7 from "../assets/images/img7.png";

const WhatWeDo = () => {
  return (
    <div className="px-4  
    border-t-[#C09462] border-b-[#C09462] border-t-[1px] border-b-[1px]">
      <h1 className="text-3xl md:text-5xl lg:text-[55px] text-center py-[52px]">
        MULTI <span className="text-[#C09462]">STRATEGY</span> ASSET CLASSES
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-7xl mx-auto px-4 justify-items-center">
        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img7}
              alt="DEEP TECH "
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">DEEP TECH</p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img1}
              alt="CROSS BORDER FUND"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">
            CROSS BORDER FUND
          </p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img2}
              alt="REAL WORLD ASSET TOKENIZATION"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">
            REAL WORLD ASSET TOKENIZATION
          </p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img3}
              alt="REAL ESTATE"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">REAL ESTATE</p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img4}
              alt="D2C"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">D2C</p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group">
          <div className="relative overflow-hidden">
            <img
              src={img5}
              alt="CLIMATE TECH"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">CLIMATE TECH</p>
        </div>

        <div className="pb-8 flex flex-col w-[336px] group col-span-1 md:col-span-3 flex items-center">
          <div className="relative overflow-hidden">
            <img
              src={img6}
              alt="ALGO TRADING"
              className="w-full h-[250px] object-cover transition-transform duration-300 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#C09462] opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </div>
          <p className="pt-[18px] text-lg text-start w-full">ALGO TRADING</p>
        </div>
      </div>
    </div>
  );
};

export default WhatWeDo;
